import { ActionTypesFactory } from "../../config/helper";

export const CustomerShipmentsList = ActionTypesFactory(
  "Shipment",
  "ShipmentList"
);
export const CustomerPaymentTerms = ActionTypesFactory(
  "Payment",
  "PaymentTerms"
);
export const CustomerShipmentTerms = ActionTypesFactory(
  "Shipment",
  "ShipmentTerms"
);
export const CustomerShipmentDoc = ActionTypesFactory(
  "Shipment",
  "SingleShipment"
);
export const CustomerBillingDoc = ActionTypesFactory("Billing", "Details");
export const CustomerBillingList = ActionTypesFactory(
  "Billing",
  "PaymentsList"
);
export const CustomerShipmentTrack = ActionTypesFactory(
  "Shipment",
  "TrackShipment"
);
export const SyncCustomerOrders = ActionTypesFactory("Sync", "Orders");
export const SyncCustomerDetails = ActionTypesFactory(
  "Sync",
  "CustomerDetails"
);
export const customerShipmentsList = (payload) => {
  return { type: CustomerShipmentsList.REQUEST, payload };
};
export const customerPaymentTerms = (payload) => {
  return { type: CustomerPaymentTerms.REQUEST, payload };
};
export const customerShipmentTerms = (payload) => {
  return { type: CustomerShipmentTerms.REQUEST, payload };
};
export const customerShipmentDoc = (payload) => {
  return { type: CustomerShipmentDoc.REQUEST, payload };
};
export const customerBillingDoc = (payload) => {
  return { type: CustomerBillingDoc.REQUEST, payload };
};
export const customerBillingList = (payload) => {
  return { type: CustomerBillingList.REQUEST, payload };
};
export const customerShipmentTrack = (payload) => {
  return { type: CustomerShipmentTrack.REQUEST, payload };
};
export const syncCustomerOrders = (payload) => {
  return { type: SyncCustomerOrders.REQUEST, payload };
};
export const syncCustomerDetails = (payload) => {
  return { type: SyncCustomerDetails.REQUEST, payload };
};
